import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UrlSignature } from '../common/apiEndpoint';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Applicants } from '../applicants/Applicants';
import { ApplicantDetails } from './applicantDetails';
import { Contact } from './contact';
import { certificate } from './certificate';
import { Course } from './course';
import { Programme } from './programme';
import { signup } from './signup';
import { Certification } from './certification';

@Injectable()
export class ApplicantsService {
  constructor(
    private httpClient: HttpClient,
    private urlSignature: UrlSignature,
  ) {}

  getPersonDetails(personId: string): Observable<ApplicantDetails> {
    const url = this.urlSignature.personDetailsUrl + personId;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as ApplicantDetails));
  }

  getContactDetails(personId: string): Observable<Contact> {
    const url = this.urlSignature.contactUrl + personId;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as Contact));
  }

  getCertificates(personId: string): Observable<certificate[]> {
    const url = this.urlSignature.certificatesUrl + '/' + personId;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as certificate[]));
  }

  getProgrammeTypes(): Observable<Programme[]> {
    const url = this.urlSignature.programmeTypesUrl;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as Programme[]));
  }

  getProgrammeList(): Observable<Programme[]> {
    const url = this.urlSignature.programmeListUrl;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as Programme[]));
  }

  getSignUpApplicant(email: string): Observable<signup> {
    const url = this.urlSignature.getSignUpUrl + email + '/';
    return this.httpClient.get(url).pipe(map((response) => response as signup));
  }

  getCertificationbyPersonId(personId: string): Observable<Certification> {
    let url = this.urlSignature.certificationUrl + '/' + personId;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as Certification));
  }
}
